const normalizeApiBase = (baseUrl) => {
  if (typeof baseUrl !== 'string') return '/api';
  return baseUrl.endsWith('/') ? baseUrl.slice(0, -1) : baseUrl;
};

const apiBaseUrl = normalizeApiBase(process.env.VUE_APP_API_BASE_URL || '/api');

export default apiBaseUrl;
